import { useState } from 'react';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import { logger } from '@zep/core-logger';
import { OptionHorizontalIcon, SquareStackIcon, TrashIcon } from '@/icons';
import { Dropdown, IconButton } from '@/ui_v3';
import { cn } from '@/utils';
export const QuizItemToolsDropdown = ({
  onCopy,
  onDelete
}: {
  onCopy: () => void;
  onDelete: () => void;
}) => {
  const {
    t
  } = useTranslation(['common']);
  const [isOpen, setIsOpen] = useState(false);
  return <Dropdown.Root modal={false} open={isOpen} onOpenChange={setIsOpen} data-sentry-element="unknown" data-sentry-component="QuizItemToolsDropdown" data-sentry-source-file="QuizItemToolsDropdown.tsx">
      <Dropdown.Trigger asChild data-sentry-element="unknown" data-sentry-source-file="QuizItemToolsDropdown.tsx">
        <IconButton className={cn('absolute right-[10px] hidden group-hover/card:flex', isOpen && 'flex')} variant="contained" intent="neutral" size="xs" onClick={e => {
        e.stopPropagation();
      }} onMouseDown={e => {
        e.stopPropagation();
      }} data-sentry-element="IconButton" data-sentry-source-file="QuizItemToolsDropdown.tsx">
          <OptionHorizontalIcon size="sm" fill={ICON_COLOR.neutral} data-sentry-element="OptionHorizontalIcon" data-sentry-source-file="QuizItemToolsDropdown.tsx" />
        </IconButton>
      </Dropdown.Trigger>
      <Dropdown.Portal data-sentry-element="unknown" data-sentry-source-file="QuizItemToolsDropdown.tsx">
        <Dropdown.Content hideWhenDetached side="bottom" align="start" className="w-auto min-w-[150px] flex-col px-xs py-3xs" onCloseAutoFocus={e => e.preventDefault()} data-sentry-element="unknown" data-sentry-source-file="QuizItemToolsDropdown.tsx">
          <Dropdown.Item onSelect={() => {
          onCopy();
          logger.track('copy_quizItem', {
            position: 'slider_dropdown'
          });
        }} data-sentry-element="unknown" data-sentry-source-file="QuizItemToolsDropdown.tsx">
            <SquareStackIcon size="sm" fill={ICON_COLOR.default} data-sentry-element="SquareStackIcon" data-sentry-source-file="QuizItemToolsDropdown.tsx" />
            {t('global.duplicate.button')}
          </Dropdown.Item>
          <Dropdown.Item onSelect={onDelete} data-sentry-element="unknown" data-sentry-source-file="QuizItemToolsDropdown.tsx">
            <TrashIcon size="sm" fill={ICON_COLOR.default} data-sentry-element="TrashIcon" data-sentry-source-file="QuizItemToolsDropdown.tsx" />
            {t('global.delete')}
          </Dropdown.Item>
        </Dropdown.Content>
      </Dropdown.Portal>
    </Dropdown.Root>;
};